import React from "react";
import { Tabs, TabList, Tab, TabIndicator, Center, Tooltip } from "@chakra-ui/react";
import { Icon } from "@chakra-ui/icons";
import { MdFormatListNumberedRtl, MdOutlineAnalytics, MdOutlineLeaderboard, MdOutlineRecordVoiceOver } from "react-icons/md";
import HomeTab from "./HomeTab";

const DetailNavigationBar = ({ onHandleTabChange }) => {
    const tabStyle = {
        color: '#73d6c2',
        _selected:
            {
                bg: 'green.100'
            }
    };

    return (
        <Center>
            <Tabs defaultIndex={1} onChange={onHandleTabChange} >
                <TabList>
                    <HomeTab />
                    <Tooltip label="Current Intake Snapshot" aria-label="Current Intake Snapshot">
                        <Tab sx={tabStyle}>
                            <Icon as={MdFormatListNumberedRtl} boxSize={8} />
                        </Tab>
                    </Tooltip>
                    <Tooltip label="Current Intake Coursewise Snapshot" aria-label="A tooltipCurrent Intake Coursewise Snapshot">
                        <Tab sx={tabStyle}>
                            <Icon as={MdOutlineAnalytics} boxSize={8} />
                        </Tab>
                    </Tooltip>
                    <Tooltip label="Coursewise Leads snapshot" aria-label="Coursewise Leads snapshot">
                        <Tab sx={tabStyle}>
                            <Icon as={MdOutlineLeaderboard} boxSize={8} />
                        </Tab>
                    </Tooltip>
                    <Tooltip label="Student counselors Performance" aria-label="Student counselors Performance">
                        <Tab sx={tabStyle}>
                            <Icon as={MdOutlineRecordVoiceOver} boxSize={8} />
                        </Tab>
                    </Tooltip>
                </TabList>
                <TabIndicator mt='-1.5px' height='2px' bg='blue.500' borderRadius='1px' />
            </Tabs>
        </Center>
    );
};

export default DetailNavigationBar;